import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Anti-aging Forms
   */
  {
    //1
    label:
      'Are you pregnant, breastfeeding, or planning to become pregnant in the near future?',
    field: 'pregnantFuture',
    type: 'polar_check',
    answer: {
      label: 'Please tell us more about your plans',
      name: 'pregnantFutureDesc',
      type: 'text'
    }
  },
  {
    // 2
    field: 'birthControl',
    label: 'Are you taking birth control? (Select one) ',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'BirthControlTabletsYes', value: 'Yes' },
        { key: 'BirthConrolTabletsNo', value: 'No' }
      ]
    }
  },
  {
    //3
    label: 'What are your skincare goals? (Select at least one, or all that apply)',
    field: 'skinGoals',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'fightBreakouts', value: 'Fight Breakouts' },
        { key: 'evenSkinTone', value: 'Even skin tone, reduce light and dark spots' },
        { key: 'treatCloggedPores', value: 'Treat Clogged Pores' },
        { key: 'firmSkin', value: 'Firm Skin' },
        { key: 'smoothSkin', value: 'Smooth Skin' },
        { key: 'reduceWrinkles', value: 'Reduce wrinkles' },
        { key: 'reduceRedness', value: 'Reduce redness and puffiness' },
        {
          key: 'allGoals',
          value: 'All of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    //4
    label: 'How sensitive is your skin to new products? (select one) ',
    field: 'skinSensitivity',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'verySensitive', value: 'Very Sensitive and easly irritated' },
        { key: 'sensitive', value: 'Sensitive and sometimes irritated ' },
        { key: 'notSensitive', value: 'Not sensitive, I can use anything ' },
        { key: 'notsure', value: 'Not sure' }
      ]
    }
  },
  {
    //5
    label: 'Do you have a preference for skin care products? ',
    field: 'skinCarePrefrence',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'waterOrGel', value: 'Water or gel based products ' },
        { key: 'cream', value: 'Cream moisturizing products' },
        { key: 'fragranceFree', value: 'Fragrance-free, sensitive skin solutions' },
        { key: 'noPreference', value: 'No preference - whatever will work best!' }
      ]
    }
  },
  {
    //8
    label: 'What are your skincare goals? (Select at least one, or all that apply)',
    field: 'skinProducts',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'nightCream', value: 'Night Cream' },
        { key: 'moisturizer', value: 'Moisturizer' },
        { key: 'masks', value: 'Masks' },
        { key: 'aha', value: 'AHA containing products (lactic acid, glycolic acid)' },
        { key: 'lightening', value: 'Lightening/brightening product (Kojic acid, hydroquinone)' },
        { key: 'exfoliator', value: 'Chemical exfoliator (BHA containing product, salacylic acid)' },
        { key: 'cleanser', value: 'Cleanser' },
        { key: 'serum', value: 'Serum' },
        { key: 'makeup', value: 'Makeup' },
        { key: 'eyecream', value: 'Eye Cream' },
        { key: 'retinoids', value: 'Retinoids, Retinols' },
        { key: 'vitC', value: 'Vitamin C products' },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    
    field: 'skinAcknowledgement',
    label:
      'I agree to have my relevant prescription information transferred to IHS Compounding Pharmacy. The information shared will be kept strictly confidential in accordance with the Ontario College of Pharmacists` regulations.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'skinAcknowledgement', value: 'I Agree' }]
    }
  }
];

export default questionsModels;